import { Component, ElementRef, HostListener, OnInit, Renderer2 } from '@angular/core';
import { UserService } from '../../services/user/user.service';
import { CommonModule } from '@angular/common';
import { Router, RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-blank',
  standalone: true,
  templateUrl: './blank.component.html',
  imports: [CommonModule, RouterOutlet]
})
export class BlankComponent implements OnInit {
  constructor(
    el: ElementRef,
    renderer: Renderer2,
    public userservice?: UserService,
    private router?: Router
  ) {
    console.log('Current route:', this.router?.url);
    const events = 'cut copy paste';
    events.split(' ').forEach(e =>
      renderer.listen(el.nativeElement, e, (event) => {
        event.preventDefault();
      })
    );
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event: any) {
    console.log('event.state', event.state);
    if (event.state == null) {
      this.userservice?.logOut(0);
    } else {
      this.userservice?.releaseOnBackButton();
    }
  }

  ngOnInit() {
    this.handleDuplicateNavigation();
  }

  private handleDuplicateNavigation() {
    try {
      const navEntries = window.performance.getEntriesByType('navigation') as PerformanceNavigationTiming[];
      const navigationType = navEntries && navEntries.length ? navEntries[0].type : null;
      console.log('navigationType', navigationType);
      if (navigationType === 'back_forward') {
        this.userservice?.logOut(2);
      }
    } catch (err) {
      console.warn('navigation detection not supported', err);
    }
  }
}
